
import {IonPage, IonContent,IonList, IonItem, IonLabel} from '@ionic/vue'
import {defineComponent} from "vue";
import {useStore} from "@/store/store";
import {useRouter} from "vue-router";
import {useI18n} from "vue-i18n";
import {Tool, ToolUtils} from "@/store/state"
export default defineComponent({
  components: {IonPage, IonContent,IonList, IonItem, IonLabel},
  name: "Tools",
  methods: {

    goToTool(tool: Tool){
      console.log("goto ",tool)
      this.router.push({name:'Tool',params:{toolId:tool.id}})
    }
  },
  computed: {
    tools(): Tool[]{
      console.log("tools",this.store.state.tools)
      return this.store.state.tools.map(tool=>ToolUtils.translate(tool,this.locale));
    }
  },
  setup(){
    const store = useStore()
    const router = useRouter()
    const {t,locale} = useI18n()
    return {
      router,
      store,
      t,
      locale
    }
  }

})
